import { PortalError } from './PortalError';

export class NoMeasurementsError extends PortalError {
  constructor() {
    super('NoMeasurementsError', 'Measurement not found', 'measurement_not_found_notification');
  }
}
